module.exports = __webpack_public_path__ + "img/stick_activites_via_ferrata.0dfcf405.svg";